const STREAK_KEY = 'explainerror_streak';
const BEST_STREAK_KEY = 'explainerror_best_streak';
const LAST_PLAYED_KEY = 'explainerror_last_played';

function getDateKey(date = new Date()): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function getYesterdayKey(): string {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return getDateKey(date);
}

export function getCurrentStreak(): number {
  return Number(localStorage.getItem(STREAK_KEY) || '0');
}

export function getBestStreak(): number {
  return Number(localStorage.getItem(BEST_STREAK_KEY) || '0');
}

export function recordChallengePlayed() {
  const today = getDateKey();
  const yesterday = getYesterdayKey();
  const lastPlayed = localStorage.getItem(LAST_PLAYED_KEY);
  let currentStreak = getCurrentStreak();

  if (lastPlayed === today) {
    return;
  }

  if (lastPlayed === yesterday) {
    currentStreak += 1;
  } else {
    currentStreak = 1;
  }

  const bestStreak = Math.max(currentStreak, getBestStreak());

  localStorage.setItem(STREAK_KEY, String(currentStreak));
  localStorage.setItem(BEST_STREAK_KEY, String(bestStreak));
  localStorage.setItem(LAST_PLAYED_KEY, today);
}